import api from 'api';

export const loadNetworks = api('GET /api/tracker/filters/networks');
export const loadBusinessPartners = api(
  'GET /api/tracker/filters/business-partners'
);
export const loadAffiliates = api('GET /api/tracker/filters/affiliates');
export const loadCampaigns = api('POST /api/tracker/filters/campaigns');

export const loadApplications = api('GET /api/tracker/filters/applications');
export const loadClusters = api('GET /api/tracker/filters/clusters');

export const loadManagers = api('GET /api/tracker/filters/managers');
export const loadOwners = api('GET /api/tracker/filters/owners');
export const loadPlatforms = api('GET /api/tracker/filters/platforms');

export const loadGenres = api('GET /api/tracker/filters/genres');
export const loadCountries = api('GET /api/tracker/filters/countries');

export const loadChannelTypes = api('GET /api/tracker/filters/channelTypes');
export const loadChannels = api('GET /api/tracker/filters/channels');
export const loadLabels = api('GET /api/tracker/filters/labels');

export const loadClients = api('GET /api/tracker/filters/clients');
export const loadDeviceTypes = api('GET /api/tracker/filters/device-types');
export const loadRealCPFlows = api('GET /api/tracker/filters/flows');

export const loadRegistrations = api('GET /api/tracker/filters/registrations');
export const loadCampaignTypes = api(
  'GET /api/tracker/filters/targetingactivitytypes'
);

export const loadFraudTypes = api('GET /api/tracker/filters/fraud-types');
export const loadReCounters = api('GET /api/tracker/filters/re-counters');
export const loadTrafficTypes = api('GET /api/tracker/filters/trafficTypes');
export const loadStatuses = api('GET /api/tracker/filters/statuses');
export const loadFilterDetails = api('POST /api/tracker/filters-details');

export const loadBriefs = api(
  'GET /api/tracker/filters/influencer-channels/briefs'
);

export const loadInfluencerChannelSubscribers = api(
  'GET /api/tracker/filters/influencer-channels/subscribers'
);
export const loadInfluencerChannelTotalViews = api(
  'GET /api/tracker/filters/influencer-channels/total-views'
);
export const loadInfluencerChannelPrices = api(
  'GET /api/tracker/filters/influencer-channels/prices'
);
export const loadInfluencerChannelSocialMediaPlatforms = api(
  'GET /api/tracker/filters/influencer-channels/social-media-platforms'
);

export const loadInfluencerChannelGenders = api(
  'GET /api/tracker/filters/influencer-channels/genders'
);
export const loadCPELiveEvents = api(
  'POST /api/tracker/filters/cpe-live-events'
);

export const loadCPELiveEventTypes = api(
  'GET /api/tracker/filters/cpe-live-event-types'
);
